export default {
  // Título del panel
  title: 'Diagnóstico',

  // Log tracker (consola y peticiones HTTP)
  logTracker: 'Log tracker',
  logTrackerHint: 'Consola y peticiones HTTP dentro de la app',

  // Modo QA offline
  qaMode: 'Modo QA offline',
  qaModeHint: 'Logger detallado y banner de sincronización siempre visible',

  // Copiar info de diagnóstico
  copyEnv: 'Copiar info de diagnóstico',
  envCopied: 'Info de diagnóstico copiada',
  copyFailed: 'No se pudo copiar',

  // Capa offline — estado y detalle tecnico
  offlineTitle: 'Capa offline',
  offlineDbOk: 'Base de datos abierta',
  offlineDbFail: 'La base de datos NO abrió',
  offlineDbFailHint: 'Reporta esto a soporte: la app no puede guardar sin conexión',
  offlineUnavailable: 'Estado no disponible',
  offlinePlatform: 'Plataforma',
  offlineBackend: 'Motor de base de datos',
  offlineSqlitePlugin: 'Plugin SQLite',
  offlineFilesystem: 'Plugin de archivos',
  offlineDebugEnabled: 'Log de depuración',
  offlineFlag: 'Modo offline activo',
  offlineLogEntries: 'Líneas de log',

  // Valores genericos de la tabla de diagnostico
  yes: 'Sí',
  no: 'No',
  empty: 'Sin dato'
}
